import { Modal, Typography } from 'antd'
import React, { ReactNode } from 'react'
import styled from 'styled-components'
import CantileverTheme from 'styles/cantileverTheme'

const { Text } = Typography

const DEFAULT_ICON_COLOR = CantileverTheme.colors.slate['400']

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const IconWrapper = styled.span`
  color: ${DEFAULT_ICON_COLOR};
`

const ContentContainer = styled.div`
  padding-top: 1rem;
  padding-bottom: 1rem;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
`

interface FullscreenModalProps {
  open: boolean
  onClose: () => void
  title: string
  icon?: ReactNode
  children: ReactNode
}

export const FullscreenModal: React.FC<FullscreenModalProps> = ({
  open,
  onClose,
  title,
  icon,
  children,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width='100vw'
      style={{
        top: 0,
        margin: 0,
        padding: 0,
        maxWidth: '100vw',
        position: 'fixed',
      }}
      styles={{
        body: {
          height: 'calc(100vh - 40px)',
        },
      }}
      destroyOnHidden={true}
      closable={true}
      maskClosable={true}>
      <HeaderContainer>
        {icon && <IconWrapper>{icon}</IconWrapper>}
        <Text strong>{title}</Text>
      </HeaderContainer>

      <ContentContainer>{children}</ContentContainer>
    </Modal>
  )
}
